import { createSlice } from '@reduxjs/toolkit';
import { displayInitialState } from './display.defaults';

export const homeArtworksDisplaySlice = createSlice({
  name: 'display',
  initialState: displayInitialState,
  reducers: {
    OPEN_FILTERS_HomeArtworks: (state) => {
      state.isFiltersDialogOpen = true;
    },
    CLOSE_FILTERS_HomeArtworks: (state) => {
      state.isFiltersDialogOpen = false;
    },
  },
});
